import '@orno/web/fonts.css';
import '@orno/web/orno.css';
import '@orno/web/orno.js';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

async function bootstrap() {
  // `vite --mode mock` (pnpm dev:mock, Playwright): answer /api/* with MSW in the browser.
  if (import.meta.env.DEV && import.meta.env.VITE_API_MOCKING === 'browser') {
    const { startMockWorker } = await import('./test/msw/browser');
    await startMockWorker();
  }

  const container = document.getElementById('root');
  if (container === null) throw new Error('#root is missing from index.html');
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
